/* tslint:disable */

/**
 */
export class TempExt {
    ID_TEMP_EXT?: number;
    ID_EQUIPSERIES?: number;
    TR?: number;
    T_EXT?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/temp-ext.ts